import { Builder } from '@builder.io/react';

import TextContent from './index';

Builder.registerComponent(TextContent, {
  name: 'TextContent',
  inputs: [
    {
      name: 'text',
      type: 'richText'
    },
    {
      name: 'centered',
      type: 'boolean'
    }
  ]
});
